import {
  USER_UPDATED_DOWN_PAYMENT,
  USER_UPDATED_TRADE_IN_VALUE,
  USER_UPDATED_CREDIT_RATING,
  TOTAL_PERSONALIZED_AMOUNT_UPDATED,
  USER_UPDATED_OFFER_FILTER,
  USER_OPENED_EDIT_TRIM_MODEL_CHOOSER,
  USER_CLOSED_EDIT_TRIM_MODEL_CHOOSER,
  USER_RESET_PERSONAL_OPTIONS,
  USER_OPENED_USER_AMOUNTS_PANEL,
  USER_CLOSED_USER_AMOUNTS_PANEL,
  APP_UPDATED_DOWN_PAYMENT,
  USER_SELECTED_TRIM,
  USER_INTERNAL_LINK,
  SYSTEM_UPDATED_CASHBACK_AMOUNT
} from '../constants';

const initialState = {
  downPayment: 0,
  tradeIn: 0,
  creditRating: '0',
  totalPersonalizedAmount: 0,
  showAllPaymentOptions: true,
  paymentOfferSortMethod: 'none',
  modelTrimSelectorOpen: false,
  userOpenedMobileSlider: false,
  defaultDownPayment: true,
  monthlyPayment: 0,
  linkPaymentType: ''
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {

    case USER_UPDATED_DOWN_PAYMENT:
      return {
        ...state,
        downPayment: action.downPayment,
        defaultDownPayment: false
      };

    case APP_UPDATED_DOWN_PAYMENT:
      return {
        ...state,
        downPayment: action.downPayment,
        defaultDownPayment: true
      };

    case USER_UPDATED_TRADE_IN_VALUE:
      return {
        ...state,
        tradeIn: action.tradeIn,
        defaultDownPayment: false
      };

    case USER_UPDATED_CREDIT_RATING:
      return {
        ...state,
        creditRating: action.creditRating,
        defaultDownPayment: true
      };

    case TOTAL_PERSONALIZED_AMOUNT_UPDATED:
      return {
        ...state,
        totalPersonalizedAmount: action.totalPersonalizedAmount
      };

    case USER_UPDATED_OFFER_FILTER:
      return {
        ...state,
        paymentOfferSortMethod: action.filter
      };

    case USER_OPENED_EDIT_TRIM_MODEL_CHOOSER:
      return {
        ...state,
        modelTrimSelectorOpen: true
      };

    case USER_CLOSED_EDIT_TRIM_MODEL_CHOOSER:
      return {
        ...state,
        modelTrimSelectorOpen: false
      };

    case USER_RESET_PERSONAL_OPTIONS:
      return {
        ...state,
        downPayment: 0,
        tradeIn: 0,
        defaultDownPayment: true
      };

    case USER_OPENED_USER_AMOUNTS_PANEL:
      return {
        ...state,
        userOpenedMobileSlider: true
      };

    case USER_CLOSED_USER_AMOUNTS_PANEL:
      return {
        ...state,
      };

    case USER_SELECTED_TRIM:
      return {
        ...state,
        defaultDownPayment: true
      };

    case USER_INTERNAL_LINK:
      return {
        ...state,
        monthlyPayment: action.monthlyPayment,
        linkPaymentType: action.linkPaymentType
      };

    case SYSTEM_UPDATED_CASHBACK_AMOUNT:
      return {
        ...state,
        cashBackAmount: action.cashBackAmount
      };

    default:
      return state
  }
}



/** WEBPACK FOOTER **
 ** ./src/redux/reducers/userAmounts.js
 **/